import { getComp } from '../../../../../utils/utils/DI'
import { BaseOptionType } from './getFormSchema'

export const getCollections = (
  territory: string | null,
  district: string | null,
  locality: string | null,
  reason: BaseOptionType | number | null,
) => {
  const territoryStore = getComp('TerritoryStore')
  const statusesStore = getComp('StatusesStore')
  const { reasons } = getComp('InstallationReasonStore')
  const categoriesStore = getComp('CategoriesStore')

  const reasonsItems: BaseOptionType[] = reasons.map((reason: any) => ({
    key: reason.value,
    value: reason.key,
  }))

  const categoriesItems = categoriesStore.collection.map((el: any) => {
    return { key: el.id, value: el.name }
  })

  // вакханалия из-за того что есть доступные типы оплаты по статусу заявки и еще
  // есть по типу оплаты и еще есть старые заявки которым вообще закон не писан -_-
  const currentReason = typeof reason === 'object' ? reason?.key : reason
  // округи ищем по региону, если старая заявка будет []
  const districts = territory
    ? (territoryStore.territories[territory]?.Territory.Districts ?? [])
    : []
  const districtOptions = districts?.map((district: any) => district.Name) ?? []
  // ищем индекс чтобы в дальнейшем искать по нему населенные пункты
  const localityIdx = districtOptions.findIndex(
    (dis: string) => dis === district,
  )
  const localities = districts[localityIdx]?.Localities ?? []
  const localitiesOptions =
    localityIdx !== -1 ? localities.map((locality: any) => locality.Name) : []
  // ищем доступные типы оплаты по округу
  const allowedFinancialSourceIds = districts[localityIdx]?.Localities.find(
    (loc: any) => loc.Name === locality,
  )?.AllowedFinancialSourceIds
  // ищем доступные типы оплаты по статусу заявки
  const paymentTypesByReason =
    statusesStore.finSourceReasons[currentReason ?? -1]

  // фильтруем сотни тысяч раз чтобы точно все совпадало
  const paymentItems: BaseOptionType[] =
    statusesStore.financialSources
      .filter((el: any) => paymentTypesByReason?.includes(el.id))
      .filter((el: any) => el.id !== 4) // 4 статус - "Не выбрана"
      .map((item: any) => ({
        key: item.id,
        value: item.name,
        iconSrc: item.imageSrc,
      })) ?? []

  const correctedPaymentItems = allowedFinancialSourceIds?.length
    ? paymentItems.filter((el: any) =>
        allowedFinancialSourceIds?.includes(el.key),
      )
    : getDefaultPaymentItems(
        (reason as BaseOptionType)?.key ?? -1,
        paymentItems,
      )

  return {
    districtOptions,
    localitiesOptions,
    localityIdx,
    districts,
    paymentItems: correctedPaymentItems,
    reasonsItems,
    categoriesItems,
    localities,
  }
}

const getDefaultPaymentItems = (reason: number, items: BaseOptionType[]) => {
  switch (reason) {
    case 3:
      return items.filter((el) => el.key !== 1)
    default:
      return items.filter((el) => el.key === 3)
  }
}
